import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon"

const Crown = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M3 18.75h18v1.5H3v-1.5Zm0-11.25 4.5 4.5L12 5.25 16.5 12l4.5-4.5v9.75H3V7.5Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default Crown
